/* eslint-disable jsx-quotes */
import React from 'react';
// import InterestingObjects from 'components/Panels/InterestingObjects/InterestingObjects';
import Map from 'components/Panels/Map/Map';
import s from './testComponent.module.css';

// const testComponent = () => {
//   return (
//     <div style={{ textAlign: 'center' }}>
//       <div style={{ display: 'inline-block', marginTop: 150 }}>
//         <InterestingObjects />
//       </div>
//     </div>
//   );
// };


const testComponent = () => {
  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ display: 'inline-block', marginTop: 100 }}>
        <div style={{ width: 1500, height: 700, position: 'relative' }}>
          <Map />
        </div>
      </div>
    </div>
  );
};

export default testComponent;
